import styles from "./styles.module.css"

function Box({children, className, ...props}) {
    return(
        <div className={`${styles.container} ${className}`} {...props}>
            {children}
        </div>
    )
}

export default Box